import React from 'react';

import { Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import MyCollapse from 'components/Collapse';
import CopyText from 'v2/components/Shared/CopyText';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';

import { TABLE_STATUS_BASE, getStatusColor } from '../statusColors';

const InvoiceDetails = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const columns: ColumnsType<ShoppingDelivery> = [
    {
      title: '',
      key: 'status',
      width: 40,
      render: (_, record) => (
        <Tooltip title={record.payment_status.name} placement='top'>
          <div className={`${TABLE_STATUS_BASE} ${getStatusColor(record.payment_status.alias)} translate-x-0!`} />
        </Tooltip>
      )
    },
    {
      title: 'Emissão',
      key: 'created',
      render: (_, record) =>
        record.created_at ? dateService.dateToString(new Date(record.created_at), 'dd/MM/yyyy') : '-'
    },
    {
      title: 'Pag.',
      key: 'paid',
      render: (_, record) =>
        record.received_at ? dateService.dateToString(new Date(record.received_at), 'dd/MM/yyyy') : '-'
    },
    {
      title: 'Valor',
      key: 'value',
      align: 'right',
      render: (_, record) =>
        record.total_value.toLocaleString('pt-BR', { style: 'currency', currency: record.currency_code })
    }
  ];

  return (
    <MyCollapse
      title={
        <span>
          Dados da fatura (<CopyText value={delivery.invoice_id}>{delivery.invoice_id}</CopyText>)
        </span>
      }
      arrow
    >
      <Table<ShoppingDelivery>
        columns={columns}
        dataSource={[delivery]}
        rowKey='invoice_id'
        pagination={false}
        size='small'
      />
    </MyCollapse>
  );
};

export default InvoiceDetails;
